<template>
  <aceHotel :revinate_token="revinate_token" :template="template" :portal="portal" :connection_data="connection_data" @emitRegistrationMethodData="handleEmit" />
</template>
<script>
import aceHotel from '@/components/custom/aceHotel/index'
export default {
  name: 'custom_template_ace_toronto',
  props: [ 'template', 'portal', 'connection_data' ],
  components: { aceHotel },
  data(){
    return{
      revinate_token: '8ce0972c-7ebf-448d-a94c-d83cc61a206a'
    }
  },
  methods: {
    handleEmit:function(data){
      this.$emit('emitRegistrationMethodData', data);
    }
  }
}
</script>
<style>
</style>